<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [hideOkButton]="!isAuthorized"
            [disabled]="!mapForm.form.valid || data.selectedItem.routingInterfaces.length === 0"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' THIRD PARTY NODE'">

  <form #mapForm="ngForm" autocomplete="off">
    <mat-form-field class="fullWidth">
      <mat-label>Name</mat-label>
      <input [(ngModel)]="data.selectedItem.name" matInput name="name" required>
      <mat-error>
        Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-label>Routing Interfaces:</mat-label>

    <div class="interfaces">
      <div class="routing-interface-list">
        <div class="routing-interface-item" *ngFor="let item of data.selectedItem.routingInterfaces; let index = index;">
          <i class="fa fa-times remove-interface" (click)="removeRoutingInterface(index)"></i>
          <div class="routing-interface">
            <mat-form-field class="name">
              <mat-label>Name</mat-label>
              <input [(ngModel)]="item.name" matInput [name]="'item-name-' + index" required>
            </mat-form-field>
            <mat-form-field class="ip-addr">
              <mat-label>IP Address</mat-label>
              <input [(ngModel)]="item.controlIpAddr" matInput [name]="'item-ip-' + index" required>
            </mat-form-field>
            <mat-form-field class="port">
              <mat-label>TCP Port</mat-label>
              <input [(ngModel)]="item.tcpPort" matInput min="1"
                     max="65535" [name]="'item-tcp-port-' + index" type="number">
            </mat-form-field>
            <mat-form-field class="port">
              <mat-label>UDP Port</mat-label>
              <input [(ngModel)]="item.udpPort" matInput min="1"
                     max="65535" [name]="'item-udp-port-' + index" type="number">
            </mat-form-field>
            <mat-form-field class="port">
              <mat-label>TLS Port</mat-label>
              <input [(ngModel)]="item.tlsPort" matInput min="1"
                     max="65535" [name]="'item-tls-port-' + index" type="number">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="routing-interface-actions">
        <button (click)="addRoutingInterface()" cy-data="add" mat-icon-button matTooltip="Add">
          <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
        </button>
      </div>
    </div>

  </form>
</arm-dialog>
